export const relationshipToInsuredOptions = [
  {
    CodeSetMasterCode: 33,
    CodeID: '2',
    EffectiveDate: '1900-01-01',
    Code: '01',
    Description: 'Spouse',
    Abbreviation: 'Spouse',
    CustomCode: 'N',
    PreserveCustomization: 'N',
  },
  {
    CodeSetMasterCode: 33,
    CodeID: '3',
    EffectiveDate: '1900-01-01',
    Code: '03',
    Description: 'Father or Mother',
    Abbreviation: 'Father or Mother',
    CustomCode: 'N',
    PreserveCustomization: 'N',
  },
  {
    CodeSetMasterCode: 33,
    CodeID: '4',
    EffectiveDate: '1900-01-01',
    Code: '04',
    Description: 'Grandfather or Grandmother',
    Abbreviation: 'Grandfather or Grandmother',
    CustomCode: 'N',
    PreserveCustomization: 'N',
  },
  {
    CodeSetMasterCode: 33,
    CodeID: '5',
    EffectiveDate: '1900-01-01',
    Code: '05',
    Description: 'Grandson or Granddaughter',
    Abbreviation: 'Grandson or Granddaughter',
    CustomCode: 'N',
    PreserveCustomization: 'N',
  },
  {
    CodeSetMasterCode: 33,
    CodeID: '6',
    EffectiveDate: '1900-01-01',
    Code: '06',
    Description: 'Uncle or Aunt',
    Abbreviation: 'Uncle or Aunt',
    CustomCode: 'N',
    PreserveCustomization: 'N',
  },
  {
    CodeSetMasterCode: 33,
    CodeID: '7',
    EffectiveDate: '1900-01-01',
    Code: '07',
    Description: 'Nephew or Niece',
    Abbreviation: 'Nephew or Niece',
    CustomCode: 'N',
    PreserveCustomization: 'N',
  },
  {
    CodeSetMasterCode: 33,
    CodeID: '8',
    EffectiveDate: '1900-01-01',
    Code: '08',
    Description: 'Cousin',
    Abbreviation: 'Cousin',
    CustomCode: 'N',
    PreserveCustomization: 'N',
  },
  {
    CodeSetMasterCode: 33,
    CodeID: '9',
    EffectiveDate: '1900-01-01',
    Code: '09',
    Description: 'Adopted Child',
    Abbreviation: 'Adopted Child',
    CustomCode: 'N',
    PreserveCustomization: 'N',
  },
  {
    CodeSetMasterCode: 33,
    CodeID: '10',
    EffectiveDate: '1900-01-01',
    Code: '10',
    Description: 'Foster Child',
    Abbreviation: 'Foster Child',
    CustomCode: 'N',
    PreserveCustomization: 'N',
  },
  {
    CodeSetMasterCode: 33,
    CodeID: '11',
    EffectiveDate: '1900-01-01',
    Code: '11',
    Description: 'Son-in-law or Daughter-in-law',
    Abbreviation: 'Son-in-law or Daughter-in-law',
    CustomCode: 'N',
    PreserveCustomization: 'N',
  },
  {
    CodeSetMasterCode: 33,
    CodeID: '12',
    EffectiveDate: '1900-01-01',
    Code: '12',
    Description: 'Brother-in-law or Sister-in-law',
    Abbreviation: 'Brother-in-law or Sister-in-la',
    CustomCode: 'N',
    PreserveCustomization: 'N',
  },
  {
    CodeSetMasterCode: 33,
    CodeID: '13',
    EffectiveDate: '1900-01-01',
    Code: '13',
    Description: 'Mother-in-law or Father-in-law',
    Abbreviation: 'Mother-in-law or Father-in-law',
    CustomCode: 'N',
    PreserveCustomization: 'N',
  },
  {
    CodeSetMasterCode: 33,
    CodeID: '14',
    EffectiveDate: '1900-01-01',
    Code: '14',
    Description: 'Brother or Sister',
    Abbreviation: 'Brother or Sister',
    CustomCode: 'N',
    PreserveCustomization: 'N',
  },
  {
    CodeSetMasterCode: 33,
    CodeID: '15',
    EffectiveDate: '1900-01-01',
    Code: '15',
    Description: 'Ward',
    Abbreviation: 'Ward',
    CustomCode: 'N',
    PreserveCustomization: 'N',
  },
  {
    CodeSetMasterCode: 33,
    CodeID: '16',
    EffectiveDate: '1900-01-01',
    Code: '17',
    Description: 'Stepson or Stepdaughter',
    Abbreviation: 'Stepson or Stepdaughter',
    CustomCode: 'N',
    PreserveCustomization: 'N',
  },
  {
    CodeSetMasterCode: 33,
    CodeID: '17',
    EffectiveDate: '1900-01-01',
    Code: '18',
    Description: 'Self',
    Abbreviation: 'Self',
    CustomCode: 'N',
    PreserveCustomization: 'N',
  },
  {
    CodeSetMasterCode: 33,
    CodeID: '18',
    EffectiveDate: '1900-01-01',
    Code: '19',
    Description: 'Child',
    Abbreviation: 'Child',
    CustomCode: 'N',
    PreserveCustomization: 'N',
  },
  {
    CodeSetMasterCode: 33,
    CodeID: '19',
    EffectiveDate: '1900-01-01',
    Code: '23',
    Description: 'Sponsored Dependent',
    Abbreviation: 'Sponsored Dependent',
    CustomCode: 'N',
    PreserveCustomization: 'N',
  },
  {
    CodeSetMasterCode: 33,
    CodeID: '20',
    EffectiveDate: '1900-01-01',
    Code: '24',
    Description: 'Dependent of a Minor Dependent',
    Abbreviation: 'Dependent of a Minor Dependent',
    CustomCode: 'N',
    PreserveCustomization: 'N',
  },
  {
    CodeSetMasterCode: 33,
    CodeID: '21',
    EffectiveDate: '1900-01-01',
    Code: '25',
    Description: 'Ex-spouse',
    Abbreviation: 'Ex-spouse',
    CustomCode: 'N',
    PreserveCustomization: 'N',
  },
  {
    CodeSetMasterCode: 33,
    CodeID: '22',
    EffectiveDate: '1900-01-01',
    Code: '26',
    Description: 'Guardian',
    Abbreviation: 'Guardian',
    CustomCode: 'N',
    PreserveCustomization: 'N',
  },
  {
    CodeSetMasterCode: 33,
    CodeID: '23',
    EffectiveDate: '1900-01-01',
    Code: '31',
    Description: 'Court Appointed Guardian',
    Abbreviation: 'Court Appointed Guardian',
    CustomCode: 'N',
    PreserveCustomization: 'N',
  },
  {
    CodeSetMasterCode: 33,
    CodeID: '24',
    EffectiveDate: '1900-01-01',
    Code: '32',
    Description: 'Mother',
    Abbreviation: 'Mother',
    CustomCode: 'N',
    PreserveCustomization: 'N',
  },
  {
    CodeSetMasterCode: 33,
    CodeID: '25',
    EffectiveDate: '1900-01-01',
    Code: '33',
    Description: 'Father',
    Abbreviation: 'Father',
    CustomCode: 'N',
    PreserveCustomization: 'N',
  },
  {
    CodeSetMasterCode: 33,
    CodeID: '26',
    EffectiveDate: '1900-01-01',
    Code: '38',
    Description: 'Collateral Dependent',
    Abbreviation: 'Collateral Dependent',
    CustomCode: 'N',
    PreserveCustomization: 'N',
  },
  {
    CodeSetMasterCode: 33,
    CodeID: '27',
    EffectiveDate: '1900-01-01',
    Code: '48',
    Description: 'Stepfather',
    Abbreviation: 'Stepfather',
    CustomCode: 'N',
    PreserveCustomization: 'N',
  },
  {
    CodeSetMasterCode: 33,
    CodeID: '28',
    EffectiveDate: '1900-01-01',
    Code: '49',
    Description: 'Stepmother',
    Abbreviation: 'Stepmother',
    CustomCode: 'N',
    PreserveCustomization: 'N',
  },
  {
    CodeSetMasterCode: 33,
    CodeID: '29',
    EffectiveDate: '1900-01-01',
    Code: '53',
    Description: 'Life Partner',
    Abbreviation: 'Life Partner',
    CustomCode: 'N',
    PreserveCustomization: 'N',
  },
  {
    CodeSetMasterCode: 33,
    CodeID: '30',
    EffectiveDate: '1900-01-01',
    Code: '60',
    Description: 'Annuitant',
    Abbreviation: 'Annuitant',
    CustomCode: 'N',
    PreserveCustomization: 'N',
  },
  {
    CodeSetMasterCode: 33,
    CodeID: '31',
    EffectiveDate: '1900-01-01',
    Code: 'D2',
    Description: 'Trustee',
    Abbreviation: 'Trustee',
    CustomCode: 'N',
    PreserveCustomization: 'N',
  },
  {
    CodeSetMasterCode: 33,
    CodeID: '32',
    EffectiveDate: '1900-01-01',
    Code: 'G8',
    Description: 'Other Relationship',
    Abbreviation: 'Other Relationship',
    CustomCode: 'N',
    PreserveCustomization: 'N',
  },
  {
    CodeSetMasterCode: 33,
    CodeID: '33',
    EffectiveDate: '1900-01-01',
    Code: 'G9',
    Description: 'Other Relative',
    Abbreviation: 'Other Relative',
    CustomCode: 'N',
    PreserveCustomization: 'N',
  },
];
